'use strict';

exports.__esModule = true;

var _emotion = require('emotion');

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _actions = require('@appbaseio/reactivecore/lib/actions');

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _helper = require('@appbaseio/reactivecore/lib/utils/helper');

var _types = require('@appbaseio/reactivecore/lib/utils/types');

var _types2 = _interopRequireDefault(_types);

var _utils = require('./utils');

var _Title = require('../../styles/Title');

var _Title2 = _interopRequireDefault(_Title);

var _Input = require('../../styles/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Button = require('../../styles/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Container = require('../../styles/Container');

var _Container2 = _interopRequireDefault(_Container);

var _FormControlList = require('../../styles/FormControlList');

var _utils2 = require('../../utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MultiList = function (_Component) {
  _inherits(MultiList, _Component);

  function MultiList(props) {
    _classCallCheck(this, MultiList);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    var defaultValue = props.defaultValue || props.value;
    var currentValueArray = props.selectedValue || defaultValue || [];
    var currentValue = {};
    currentValueArray.forEach(function (item) {
      currentValue[item] = true;
    });
    var options = props.options && props.options[props.dataField] ? _this.getOptions(props.options[props.dataField].buckets, props) : [];
    _this.state = {
      currentValue: currentValue,
      options: options,
      searchTerm: '',
      after: {},
      // for composite aggs
      isLastBucket: false
    };
    _this.locked = false;
    _this.internalComponent = props.componentId + '__internal';
    props.addComponent(props.componentId);
    props.addComponent(_this.internalComponent);
    props.setQueryListener(props.componentId, props.onQueryChange, props.onError);

    _this.updateQueryOptions(props);

    _this.setReact(props);

    var hasMounted = false;

    if (currentValueArray.length) {
      _this.setValue(currentValueArray, true, props, hasMounted);
    }

    return _this;
  }

  MultiList.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    (0, _helper.checkPropChange)(this.props.react, prevProps.react, function () {
      return _this2.setReact(_this2.props);
    });
    (0, _helper.checkPropChange)(this.props.options, prevProps.options, function () {
      var _props = _this2.props,
          showLoadMore = _props.showLoadMore,
          dataField = _props.dataField,
          options = _props.options;

      if (showLoadMore) {
        var buckets = options[dataField].buckets;
        var after = options[dataField].after_key; // detect the last bucket by checking if the after key is absent

        var isLastBucket = !after;

        _this2.setState(function (state) {
          return _extends({}, state, {
            after: after ? {
              after: after
            } : state.after,
            isLastBucket: isLastBucket,
            options: _this2.getOptions(buckets, _this2.props)
          });
        }, function () {
          // this will ensure that the Select-All (or any)
          // value gets handled on the initial load and
          // consecutive loads
          var currentValue = _this2.state.currentValue;
          var value = Object.keys(currentValue).filter(function (item) {
            return currentValue[item];
          });
          if (value.length) _this2.setValue(value, true);
        });
      } else {
        _this2.setState({
          options: options[dataField] ? _this2.getOptions(options[dataField].buckets, _this2.props) : []
        }, function () {
          // this will ensure that the Select-All (or any)
          // value gets handled on the initial load and
          // consecutive loads
          var currentValue = _this2.state.currentValue;
          var value = Object.keys(currentValue).filter(function (item) {
            return currentValue[item];
          });
          if (value.length) _this2.setValue(value, true);
        });
      }
    });
    (0, _helper.checkSomePropChange)(this.props, prevProps, ['size', 'sortBy'], function () {
      return _this2.updateQueryOptions(_this2.props);
    });
    (0, _helper.checkSomePropChange)(this.props, prevProps, ['dataField', 'nestedField'], function () {
      _this2.updateQueryOptions(_this2.props);

      _this2.updateQuery(Object.keys(_this2.state.currentValue), _this2.props);
    });
    var selectedValue = Object.keys(this.state.currentValue);
    var selectAllLabel = this.props.selectAllLabel;

    if (selectAllLabel) {
      selectedValue = selectedValue.filter(function (val) {
        return val !== selectAllLabel;
      });

      if (this.state.currentValue[selectAllLabel]) {
        selectedValue = [selectAllLabel];
      }
    }

    if (this.props.value !== prevProps.value) {
      this.setValue(this.props.value, true);
    } else if (!(0, _helper.isEqual)(selectedValue, this.props.selectedValue) && !(0, _helper.isEqual)(this.props.selectedValue, prevProps.selectedValue)) {
      var _props2 = this.props,
          value = _props2.value,
          onChange = _props2.onChange;

      if (value === undefined) {
        this.setValue(this.props.selectedValue || [], true);
      } else if (onChange) {
        onChange(this.props.selectedValue || null);
      } else {
        var selectedListItems = Object.keys(this.state.currentValue);
        this.setValue(selectedListItems, true);
      }
    }
  };

  MultiList.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.removeComponent(this.props.componentId);
    this.props.removeComponent(this.internalComponent);
  };

  MultiList.generateQueryOptions = function generateQueryOptions(props, after) {
    var queryOptions = (0, _helper.getQueryOptions)(props);
    return props.showLoadMore ? (0, _utils.getCompositeAggsQuery)(queryOptions, props, after) : (0, _utils.getAggsQuery)(queryOptions, props);
  };

  MultiList.prototype.render = function render() {
    var _this3 = this;

    var _props3 = this.props,
        selectAllLabel = _props3.selectAllLabel,
        renderItem = _props3.renderItem,
        showLoadMore = _props3.showLoadMore,
        loadMoreLabel = _props3.loadMoreLabel,
        renderError = _props3.renderError,
        error = _props3.error;
    var isLastBucket = this.state.isLastBucket;

    if (this.props.isLoading && this.props.loader) {
      return this.props.loader;
    }

    if (renderError && error) {
      return (0, _utils2.isFunction)(renderError) ? renderError(error) : renderError;
    }

    if (this.state.options.length === 0) {
      return null;
    }

    var itemsToRender = this.state.options;

    if (this.props.transformData) {
      itemsToRender = this.props.transformData(itemsToRender);
    }

    var listItems = itemsToRender.filter(function (item) {
      if (String(item.key).length) {
        if (_this3.props.showSearch && _this3.state.searchTerm) {
          return String(item.key).toLowerCase().includes(_this3.state.searchTerm.toLowerCase());
        }

        return true;
      }

      return false;
    });
    return _react2.default.createElement(_Container2.default, {
      style: this.props.style,
      className: this.props.className
    }, this.props.title && _react2.default.createElement(_Title2.default, {
      className: (0, _helper.getClassName)(this.props.innerClass, 'title') || null
    }, this.props.title), this.renderSearch(), _react2.default.createElement(_FormControlList.UL, {
      className: (0, _helper.getClassName)(this.props.innerClass, 'list') || null
    }, selectAllLabel ? _react2.default.createElement('li', {
      key: selectAllLabel,
      className: '' + (this.state.currentValue[selectAllLabel] ? 'active' : '')
    }, _react2.default.createElement(_FormControlList.Checkbox, {
      className: (0, _helper.getClassName)(this.props.innerClass, 'checkbox') || null,
      id: this.props.componentId + '-' + selectAllLabel,
      name: selectAllLabel,
      value: selectAllLabel,
      onChange: this.handleClick,
      checked: !!this.state.currentValue[selectAllLabel],
      show: this.props.showCheckbox
    }), _react2.default.createElement('label', {
      className: (0, _helper.getClassName)(this.props.innerClass, 'label') || null,
      htmlFor: this.props.componentId + '-' + selectAllLabel
    }, selectAllLabel)) : null, listItems.length ? listItems.map(function (item) {
      return _react2.default.createElement('li', {
        key: item.key,
        className: '' + (_this3.state.currentValue[item.key] ? 'active' : '')
      }, _react2.default.createElement(_FormControlList.Checkbox, {
        className: (0, _helper.getClassName)(_this3.props.innerClass, 'checkbox') || null,
        id: _this3.props.componentId + '-' + item.key,
        name: _this3.props.componentId,
        value: item.key,
        onChange: _this3.handleClick,
        checked: !!_this3.state.currentValue[item.key],
        show: _this3.props.showCheckbox
      }), _react2.default.createElement('label', {
        className: (0, _helper.getClassName)(_this3.props.innerClass, 'label') || null,
        htmlFor: _this3.props.componentId + '-' + item.key
      }, renderItem ? renderItem(item.key, item.doc_count, !!_this3.state.currentValue[item.key]) : _react2.default.createElement('span', null, _react2.default.createElement('span', null, item.key), _this3.props.showCount && _react2.default.createElement('span', {
        className: (0, _helper.getClassName)(_this3.props.innerClass, 'count') || null
      }, item.doc_count))));
    }) // prettier-ignore
    : this.props.renderNoResults && this.props.renderNoResults(), showLoadMore && !isLastBucket && _react2.default.createElement('div', {
      className: (0, _emotion.css)(_Button.loadMoreContainer)
    }, _react2.default.createElement(_Button2.default, {
      onClick: this.handleLoadMore
    }, loadMoreLabel))));
  };

  return MultiList;
}(_react.Component);

MultiList.defaultQuery = function (value, props) {
  var query = null;
  var type = props.queryFormat === 'or' ? 'terms' : 'term';

  if (!Array.isArray(value) || value.length === 0) {
    return null;
  }

  if (props.selectAllLabel && value.includes(props.selectAllLabel)) {
    if (props.showMissing) {
      query = {
        match_all: {}
      };
    } else {
      query = {
        exists: {
          field: props.dataField
        }
      };
    }
  } else if (value) {
    var listQuery = void 0;

    if (props.queryFormat === 'or') {
      if (props.showMissing) {
        var _type, _ref;

        var hasMissingTerm = value.includes(props.missingLabel);
        var should = [(_ref = {}, _ref[type] = (_type = {}, _type[props.dataField] = value.filter(function (item) {
          return item !== props.missingLabel;
        }), _type), _ref)];

        if (hasMissingTerm) {
          should = should.concat({
            bool: {
              must_not: {
                exists: {
                  field: props.dataField
                }
              }
            }
          });
        }

        listQuery = {
          bool: {
            should: should
          }
        };
      } else {
        var _type2, _listQuery;

        listQuery = (_listQuery = {}, _listQuery[type] = (_type2 = {}, _type2[props.dataField] = value, _type2), _listQuery);
      }
    } else {
      // adds a sub-query with must as an array of objects for each term/value
      var queryArray = value.map(function (item) {
        var _type3, _ref2;

        return _ref2 = {}, _ref2[type] = (_type3 = {}, _type3[props.dataField] = item, _type3), _ref2;
      });
      listQuery = {
        bool: {
          must: queryArray
        }
      };
    }

    query = value.length ? listQuery : null;
  }

  if (query && props.nestedField) {
    return {
      query: {
        nested: {
          path: props.nestedField,
          query: query
        }
      }
    };
  }

  return query;
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setReact = function (props) {
    var react = props.react;

    if (react) {
      var newReact = (0, _helper.pushToAndClause)(react, _this4.internalComponent);
      props.watchComponent(props.componentId, newReact);
    } else {
      props.watchComponent(props.componentId, {
        and: _this4.internalComponent
      });
    }
  };

  this.getOptions = function (buckets, props) {
    if (props.showLoadMore) {
      return buckets.map(function (bucket) {
        return {
          key: bucket.key[props.dataField],
          doc_count: bucket.doc_count
        };
      });
    }

    return buckets;
  };

  this.setValue = function (value) {
    var isDefaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this4.props;
    var hasMounted = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true; // ignore state updates when component is locked

    if (props.beforeValueChange && _this4.locked) {
      return;
    }

    _this4.locked = true;
    var selectAllLabel = props.selectAllLabel;
    var currentValue = _this4.state.currentValue;
    var finalValues = null;

    if (selectAllLabel && (Array.isArray(value) && value.includes(selectAllLabel) || typeof value === 'string' && value === selectAllLabel)) {
      if (currentValue[selectAllLabel] && hasMounted && !isDefaultValue) {
        currentValue = {};
        finalValues = [];
      } else {
        _this4.state.options.forEach(function (item) {
          currentValue[item.key] = true;
        });

        currentValue[selectAllLabel] = true;
        finalValues = [selectAllLabel];
      }
    } else if (isDefaultValue) {
      finalValues = value;
      currentValue = {};

      if (value) {
        value.forEach(function (item) {
          currentValue[item] = true;
        });
      }

      if (selectAllLabel && selectAllLabel in currentValue) {
        var _currentValue = currentValue,
            del = _currentValue[selectAllLabel],
            obj = _objectWithoutProperties(_currentValue, [selectAllLabel]);

        currentValue = _extends({}, obj);
      }
    } else {
      if (currentValue[value]) {
        var _currentValue2 = currentValue,
            _del = _currentValue2[value],
            rest = _objectWithoutProperties(_currentValue2, [value]);

        currentValue = _extends({}, rest);
      } else {
        currentValue[value] = true;
      }

      if (selectAllLabel && selectAllLabel in currentValue) {
        var _currentValue3 = currentValue,
            _del2 = _currentValue3[selectAllLabel],
            _obj = _objectWithoutProperties(_currentValue3, [selectAllLabel]);

        currentValue = _extends({}, _obj);
      }

      finalValues = Object.keys(currentValue);
    }

    var performUpdate = function performUpdate() {
      var handleUpdates = function handleUpdates() {
        _this4.updateQuery(finalValues, props);

        _this4.locked = false;
        if (props.onValueChange) props.onValueChange(finalValues);
      };

      if (hasMounted) {
        _this4.setState({
          currentValue: currentValue
        }, handleUpdates);
      } else {
        handleUpdates();
      }
    };

    (0, _helper.checkValueChange)(props.componentId, finalValues, props.beforeValueChange, performUpdate);
  };

  this.updateQuery = function (value, props) {
    var customQuery = props.customQuery;
    var query = MultiList.defaultQuery(value, props);
    var customQueryOptions = void 0;

    if (customQuery) {
      var _ref3 = customQuery(value, props) || {};

      query = _ref3.query;
      customQueryOptions = (0, _helper.getOptionsFromQuery)(customQuery(value, props));
    }

    props.setQueryOptions(props.componentId, customQueryOptions);
    props.updateQuery({
      componentId: props.componentId,
      query: query,
      value: value,
      label: props.filterLabel,
      showFilter: props.showFilter,
      URLParams: props.URLParams,
      componentType: 'MULTILIST'
    });
  };

  this.updateQueryOptions = function (props) {
    var addAfterKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false; // when using composite aggs flush the current options for a fresh query

    if (props.showLoadMore && !addAfterKey) {
      _this4.setState({
        options: []
      });
    } // for a new query due to other changes don't append after to get fresh results


    var queryOptions = MultiList.generateQueryOptions(props, addAfterKey ? _this4.state.after : {});

    if (props.defaultQuery) {
      var value = Object.keys(_this4.state.currentValue);
      var defaultQueryOptions = (0, _helper.getOptionsFromQuery)(props.defaultQuery(value, props));
      props.setQueryOptions(_this4.internalComponent, _extends({}, queryOptions, defaultQueryOptions));
    } else {
      props.setQueryOptions(_this4.internalComponent, queryOptions);
    }
  };

  this.handleInputChange = function (e) {
    var value = e.target.value;

    _this4.setState({
      searchTerm: value
    });
  };

  this.handleLoadMore = function () {
    var queryOptions = MultiList.generateQueryOptions(_this4.props, _this4.state.after);

    _this4.props.loadMore(_this4.props.componentId, queryOptions);
  };

  this.renderSearch = function () {
    if (_this4.props.showSearch) {
      return _react2.default.createElement(_Input2.default, {
        className: (0, _helper.getClassName)(_this4.props.innerClass, 'input') || null,
        onChange: _this4.handleInputChange,
        value: _this4.state.searchTerm,
        placeholder: _this4.props.placeholder,
        style: {
          margin: '0 0 8px'
        },
        themePreset: _this4.props.themePreset
      });
    }

    return null;
  };

  this.handleClick = function (e) {
    var _props4 = _this4.props,
        value = _props4.value,
        onChange = _props4.onChange;
    var listValue = e.target.value;

    if (value === undefined) {
      _this4.setValue(listValue);
    } else if (onChange) {
      onChange(listValue);
    }
  };
};

MultiList.propTypes = {
  addComponent: _types2.default.funcRequired,
  removeComponent: _types2.default.funcRequired,
  setQueryListener: _types2.default.funcRequired,
  setQueryOptions: _types2.default.funcRequired,
  loadMore: _types2.default.funcRequired,
  updateQuery: _types2.default.funcRequired,
  watchComponent: _types2.default.funcRequired,
  options: _types2.default.options,
  selectedValue: _types2.default.selectedValue,
  // component props
  beforeValueChange: _types2.default.func,
  className: _types2.default.string,
  componentId: _types2.default.stringRequired,
  customQuery: _types2.default.func,
  defaultQuery: _types2.default.func,
  dataField: _types2.default.stringRequired,
  error: _types2.default.title,
  nestedField: _types2.default.string,
  defaultValue: _types2.default.stringArray,
  value: _types2.default.stringArray,
  filterLabel: _types2.default.string,
  innerClass: _types2.default.style,
  isLoading: _types2.default.bool,
  loader: _types2.default.title,
  onError: _types2.default.func,
  renderNoResults: _types2.default.func,
  onQueryChange: _types2.default.func,
  onValueChange: _types2.default.func,
  onChange: _types2.default.func,
  placeholder: _types2.default.string,
  queryFormat: _types2.default.queryFormatSearch,
  react: _types2.default.react,
  renderItem: _types2.default.func,
  renderError: _types2.default.title,
  transformData: _types2.default.func,
  selectAllLabel: _types2.default.string,
  showCheckbox: _types2.default.boolRequired,
  showCount: _types2.default.bool,
  showSearch: _types2.default.bool,
  size: _types2.default.number,
  sortBy: _types2.default.sortByWithCount,
  style: _types2.default.style,
  themePreset: _types2.default.themePreset,
  title: _types2.default.title,
  URLParams: _types2.default.bool,
  showMissing: _types2.default.bool,
  missingLabel: _types2.default.string,
  showLoadMore: _types2.default.bool,
  loadMoreLabel: _types2.default.title
};
MultiList.defaultProps = {
  className: null,
  placeholder: 'Search',
  queryFormat: 'or',
  showCheckbox: true,
  showCount: true,
  showSearch: true,
  size: 100,
  sortBy: 'count',
  style: {},
  URLParams: false,
  showMissing: false,
  missingLabel: 'N/A',
  showLoadMore: false,
  loadMoreLabel: 'Load More'
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    options: props.nestedField && state.aggregations[props.componentId] ? state.aggregations[props.componentId].reactivesearch_nested : state.aggregations[props.componentId],
    selectedValue: state.selectedValues[props.componentId] && state.selectedValues[props.componentId].value || null,
    isLoading: state.isLoading[props.componentId],
    themePreset: state.config.themePreset,
    error: state.error[props.componentId]
  };
};

var mapDispatchtoProps = function mapDispatchtoProps(dispatch) {
  return {
    addComponent: function addComponent(component) {
      return dispatch((0, _actions.addComponent)(component));
    },
    removeComponent: function removeComponent(component) {
      return dispatch((0, _actions.removeComponent)(component));
    },
    setQueryOptions: function setQueryOptions(component, props) {
      return dispatch((0, _actions.setQueryOptions)(component, props));
    },
    loadMore: function loadMore(component, aggsQuery) {
      return dispatch((0, _actions.loadMore)(component, aggsQuery, true, true));
    },
    setQueryListener: function setQueryListener(component, onQueryChange, beforeQueryChange) {
      return dispatch((0, _actions.setQueryListener)(component, onQueryChange, beforeQueryChange));
    },
    updateQuery: function updateQuery(updateQueryObject) {
      return dispatch((0, _actions.updateQuery)(updateQueryObject));
    },
    watchComponent: function watchComponent(component, react) {
      return dispatch((0, _actions.watchComponent)(component, react));
    }
  };
};

var ConnectedComponent = (0, _utils2.connect)(mapStateToProps, mapDispatchtoProps)(function (props) {
  return _react2.default.createElement(MultiList, _extends({
    ref: props.myForwardedRef
  }, props));
}); // eslint-disable-next-line

var ForwardRefComponent = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(ConnectedComponent, _extends({}, props, {
    myForwardedRef: ref
  }));
});

(0, _hoistNonReactStatics2.default)(ForwardRefComponent, MultiList);
ForwardRefComponent.name = 'MultiList';
exports.default = ForwardRefComponent;